<template>
  <div
    class="flex gap-4 items-center cursor-pointer text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-xl p-2"
    @click="handleProblemClicked(problem.id)"
  >
    <div class="flex shrink-0 w-12 h-12">
      <img
        :src="problem.thumbnail.thumbnail_url"
        alt=""
        class="aspect-square object-cover rounded-[10px]"
      />
    </div>
    <div class="grow">
      <span class="text-sm text-gray-800 line-clamp-2">{{
        problem.description
      }}</span>
    </div>
    <div class="w-9 h-9 grid place-items-center flex-shrink-0">
      <ChevronRightIcon class="w-5 h-5 text-brand-500" />
    </div>
  </div>
</template>

<script setup>
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { usePage } from "@inertiajs/vue3";
import ChevronRightIcon from "@/Tailwind/Icon/ChevronRight.vue";

defineProps({ problem: Object });

const tenant = usePage().props.tenant;

function handleProblemClicked(problem) {
  router.get(route("problem.replies", [tenant.slug, problem]));
}
</script>
